import {useState, useEffect} from 'react'
import {Notification} from '../components/ui/index'
import {validateEmail} from '../utils/helpers.util'
import useTranslation from '../translation/hook'
import '../components/login.component.css'


import { useRouter } from '../state/route.state'
import{ useAuth } from '../state/auth.state'

import { Input, Button } from './ui'

export default function LoginRoute(props){

    const t = useTranslation()
    
    const [state, setState] = useState({
        email: "",
        password: "",
        showNotification: false,
        notificationMessage: "",
        redirect: false,
        error: false
    })
    
    const {methods } = useRouter()
    const {methods:authMethods, state:authState} = useAuth()
    
    function credentialVerification(){
        const {email, password} = state
        let errorMessage = "credenziali invalide"
        let passed = false
        if(password.length > 2 && validateEmail(email)){
            passed = true
        } else {
            if(!validateEmail(email)) errorMessage = "Email non valida"
            else errorMessage = "Password troppo corta"
        }
        return {
            passed,
            errorMessage
        }
    }
    
    
    async function handleLogin(){
        
        const {passed, errorMessage} = credentialVerification()
        
        if(!passed) {
            toggleNotification(true, errorMessage, false, true)
            return
        }
        
        try{
            const data = await authMethods.loginUser(state.email, state.password) 
            toggleNotification(true, "login effettuato con successo, reindirizzamento in corso...", true)
        } catch(err){
            toggleNotification(true, "email / password errata", false, true)
        }
    }
    
    
    function handleNotificationClose(){
        toggleNotification()
        if(state.redirect) methods.changeRoute("review")    
    }
    
    
    function handleInput(event){
        setState(oldState => ({
            ...oldState,
            [event.target.name]:event.target.value
        }))
    }
    
    function toggleNotification(val=null, message="", redirect=false, error=false){        
        setState(oldState => ({
            ...oldState,
            notificationMessage: message,
            showNotification: val != null ? val : !oldState.showNotification,
            redirect,
            error
        }))
    }
    
    
    useEffect(() => {
        if(authState.loggedIn) methods.changeRoute("review")
    },[])
    
    
    return <div className="login-container">
        <div className="modal">
            <div className="modal-header" >{t("site_pages_shop_app_payment_login")}</div>
            <div className="modal-form">
                <Notification visible={state.showNotification} error={state.error} title={state.notificationMessage} timeOut={1500} onTimeOut={handleNotificationClose}/>
                <div className="form-field">
                    <p>Email</p>
                    <Input onChange={handleInput} name="email" value={state.email}/>
                </div>
                <div className="form-field">
                    <p>Password:</p>
                    <Input onChange={handleInput} name="password" type="password" value={state.password}/>
                </div>
                <div className="form-field form-field-centered form-field-flex">
                    <Button value={t("site_pages_shop_app_back_button")} onClick={() => methods.changeRoute("app")}/>
                    <Button value={t("site_pages_shop_app_login_button")} onClick={handleLogin} extraClass="login-button" />
                </div>
                <div className="form-field form-field-centered" style={{marginTop: 20}}>
                    {t("site_pages_shop_app_not_registered")} <a href="/register">{t("site_pages_shop_app_click_here")}</a>
                </div>
            </div>
        </div>
    </div>
}
